module.exports = __webpack_public_path__ + "img/check-mark.eb94e812.svg";